import React,{ useState , useEffect } from 'react';
import logo from '../../images/logo_purple.png';
import { FormControl } from '@material-ui/core';
import { CustomLabel, CustomOptions,CustomButton } from "@tracknme/material-ui";
import { useDispatch, useSelector } from 'react-redux';
import * as Actions from '../../store/actions';
import Grid from '@material-ui/core/Grid';
import '../../mobile.css';


function Step5() {

  const dispatch = useDispatch();
  
  const { register,navigation } = useSelector(({register}) => register);

  const [options1,setOptions1] = useState(false);
  const [options2,setOptions2] = useState(false);
  const [options3,setOptions3] = useState(false);
  const [options4,setOptions4] = useState(false);
  const [tos,setTos] = useState(false);
  const [loadData,setLoadData] = useState(false);
  const [nextStep,setNextStep] = useState(false);

  useEffect(() => {

    if(!loadData && register && register.brand && register.brand.purposeOfUse &&  register.brand.purposeOfUse.length > 0){

      register.brand.purposeOfUse.forEach(purpose => {

        if(purpose === "Revenda de Rastreadores"){
          setOptions1(true)
        }
        if(purpose === "Plataforma de Rastreamento"){
          setOptions2(true)
        }
        if(purpose === "Gerenciamento de Clientes"){
          setOptions3(true)
        }
        if(purpose === "Outros"){
          setOptions4(true)
        }
        
      });

      setTos(true)
      setLoadData(true)

    }

  }, [loadData,register ]);

  function changeOptions1Value (event){
   setOptions1(options1 ? false : true)
  }
  function changeOptions2Value (){
    setOptions2(options2 ? false : true)
  }
  function changeOptions3Value (){
    setOptions3(options3 ? false : true)
  }
  function changeOptions4Value (){
    setOptions4(options4 ? false : true)
  }
  function changeTosValue (){
    setTos(tos ? false : true)
  }

  function changeButtonValue (){
    window.open("https://site.tracknme.com.br/politica_privacidade/");
  }

  useEffect(() => {
    
    if(tos  &&(options1 || options2 || options3 || options4)){
    
      dispatch(Actions.setNavigation(false));
      
      let purposeOfUse = [];

      if(options1){
        purposeOfUse.push("Revenda de Rastreadores")
      }
      if(options2){
        purposeOfUse.push("Plataforma de Rastreamento")
      }
      if(options3){
        purposeOfUse.push("Gerenciamento de Clientes")
      }
      if(options4){
        purposeOfUse.push("Outros")
      }

      let _register = register ? register : {brand:{'purposeOfUse':[]}};

      if(_register){
        _register['brand']['purposeOfUse'] = purposeOfUse;
      }
         
      dispatch(Actions.setRegister(_register));
      setNextStep(true);
      
    }else if(!navigation){
      setNextStep(false);
    }
  }, [tos, options1, options2, options3, options4,register, navigation,dispatch]);

  function changeBackStepValue() {
    dispatch(Actions.setStep(3));
  }
  
  function changeNextStepValue() {
    dispatch(Actions.setStep(5));
  }

  return (
    <div className="menuMobile">
        <div className="containerMobile">
        
            <div className="containerImage" >
                <img src={logo} className="logo" alt="Trackn'Me" />
            </div>
      
            <div className="titleStep4" >
                <CustomLabel  label="Você está procurando uma solução para qual finalidade?" color="initial" component="h4" variant="h4" style={{fontSize:14, fontWeight:700, color:'#4D39E9'}} />  
            </div>

             <div className="textField">
                <FormControl>
                  <CustomOptions   label="Revenda de Rastreadores"  name="options1" border={true} checked={options1} handleChange={changeOptions1Value} style={{width:'84vw', backgroundColor:'white', height:46}}/>   
                  <CustomOptions   label="Plataforma de Rastreamento"  name="options2" checked={options2} border={true} handleChange={changeOptions2Value} style={{width:'84vw', backgroundColor:'white', height:46}}/> 
                  <CustomOptions   label="Gerenciamento de Clientes"  name="options3" checked={options3} border={true} handleChange={changeOptions3Value} style={{width:'84vw', backgroundColor:'white', height:46}}/>   
                  <CustomOptions   label="Outros"  name="options4" border={true} checked={options4} handleChange={changeOptions4Value} style={{width:'84vw', backgroundColor:'white', height:46}}/>   
                </FormControl>  

                <div className="conteudo_top_step3">
                <div className="styleContainer">
                  <CustomOptions  label=""  name="options" border={false} checked={tos} handleChange={changeTosValue} style={{width:30, backgroundColor:'transparent', height:46, color:'black'}}/> 
                  <CustomLabel  label="Li e concordo com os " color="initial" component="h6" variant="h6" style={{fontSize:16, fontWeight:'400', color:"black"}} /> 
                  <div className="pointer" onClick={() => changeButtonValue()}>
                    <CustomLabel  label=" termos de uso." color="initial" component="h6" variant="h6" style={{fontSize:16, fontWeight:'400', color:"orange", marginLeft:'5px'}} />
                  </div>
                </div>
                </div>
            </div>
         
          
        </div>

        <div className="footer">
          <Grid container spacing={1}>
            <Grid item xs={4}  >
             
              <div className="center">
                <CustomButton disabled={false} onClick={() => changeBackStepValue()} variant="contained" color="primary" label="Voltar" style={{height:'40px',marginTop:'20px', color:'#4D39E9', backgroundColor:'white', border: '3px solid #4D39E9'}}/> 
              </div>
            </Grid>
            <Grid item xs={4} >
              <div className="center">
                <CustomLabel  label=" Passo 4 – 6" color="initial" component="h4" variant="h4" style={{fontSize:14, fontWeight:400, color:'#929292', marginTop:'35px'}} />  
              </div>
            </Grid>
            <Grid item xs={4} >
            <div className="center"><CustomButton   disabled={false} onClick={() => nextStep ? changeNextStepValue() : {}} variant="contained" color="primary" label="Avançar" style={nextStep ? {height:'40px',marginTop:'20px'} : {height:'40px',marginTop:'20px',backgroundColor:'#BFBFBF'}}/> </div>
            </Grid>
          </Grid>
          
        </div>
        
       
        
     </div>
    
  );
}

export default Step5;

